import React from "react";
import PropTypes from "prop-types";
import Image from "../ImageElement";
import "../../css/Cards/CardText.css";

/**
 * CardText component
 */
class CardText extends React.Component {
  static displayName = "CardText";
  static propTypes = {
    className: PropTypes.string,
    card: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardText";
    this.state = {
      numImages: 0,
    };
  }

  /**
   * @override
   */
  componentDidMount() {
    const numImages = Math.ceil(this.text.clientHeight / 277);
    this.setState({ numImages });
  }

  /**
   * @override
   */
  componentDidUpdate() {
    const numImages = Math.ceil(this.text.clientHeight / 277);
    if (numImages !== this.state.numImages) this.setState({ numImages });
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__title`}>
          {this.props.card.Title}
        </div>
        <div className={`${this.className}__content`}>
          <div className={`${this.className}__images`}>
            {this.props.card
              .images()
              .slice(0, this.state.numImages)
              .map((image) => (
                <div key={image.ID} className={`${this.className}__img`}>
                  <Image
                    src={image[`${this.props.screen}_src`]}
                    alt={image.alt}
                  />
                </div>
              ))}
          </div>
          <div className={`${this.className}__text`}>
            <div
              className={`${this.className}__html`}
              ref={(t) => (this.text = t)}
              dangerouslySetInnerHTML={{
                __html: this.props.card.Content,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CardText;



// WEBPACK FOOTER //
// ./src/components/Cards/CardText.js